export default "__VITE_ASSET__b1e13490__"